import { PARAMS_CONFIG } from "./grantDefaultParams";

export function initializeParametersData() {
    const data = {};

    PARAMS_CONFIG.forEach(param => {
        data[param.key] = {
            name: param.label,
            equipment: null,
            equipmentField: null,
            alertValueStart: "",
            alertValueEnd: "",
            criticalValueStart: "",
            criticalValueEnd: "",
            exceededValueStart: "",
            exceededValueEnd: "",
            isActive: false,
            ...(param.extraFieldName && {
                [param.extraFieldName]:
                    param.extraFieldDefaultValue ||
                    param.extraOptions?.[0]?.value ||
                    null
            })
        };
    });

    return data;
}

export function mapSavedParamsToState(savedParams, fieldsByEquipment) {
    const updated = initializeParametersData();
    const equipmentFieldsMap = {};

    for (const item of savedParams) {
        const configMatch = PARAMS_CONFIG.find(param =>
            param.parameter === item.tipo &&
            (!param.extraFieldName || param.extraFieldDefaultValue === item.condicao?.agrupamento)
        );

        if (!configMatch) continue;

        const key = configMatch.key;

        const fields = fieldsByEquipment[item.equipamento_id] || [];

        equipmentFieldsMap[key] = fields;

        updated[key] = {
            ...updated[key],
            isActive: item.ativo || false,
            id: item.id,
            equipment: item.equipamento_id,
            equipmentField: item.parametro_id,
            alertValueStart: item.condicao?.alerta?.inicio ?? "",
            alertValueEnd: item.condicao?.alerta?.fim ?? "",
            criticalValueStart: item.condicao?.critico?.inicio ?? "",
            criticalValueEnd: item.condicao?.critico?.fim ?? "",
            exceededValueStart: item.condicao?.excedido?.inicio ?? "",
            exceededValueEnd: item.condicao?.excedido?.fim ?? "",
            ...(configMatch.extraFieldName && {
                [configMatch.extraFieldName]:
                    item.condicao?.[configMatch.extraFieldName] ||
                    updated[key][configMatch.extraFieldName]
            })
        };
    }

    return { updated, equipmentFieldsMap };
}

export function buildPayload(parametersData) {
    const list = [];

    PARAMS_CONFIG.forEach(param => {
        const data = parametersData[param.key];

        const payload = {
            equipment: data.equipment,
            id: data.id,
            name: data.name,
            parameter: param.parameter,
            equipment_field: data.equipmentField || null,
            alert_value: {
                start: data.alertValueStart,
                end: data.alertValueEnd
            },
            critical_value: {
                start: data.criticalValueStart,
                end: data.criticalValueEnd
            },
            exceeded_value: {
                start: data.exceededValueStart,
                end: data.exceededValueEnd
            },
            is_active: data.isActive
        };

        if (param.extraFieldName) {
            payload[param.extraFieldName] = data[param.extraFieldName];
        }

        list.push(payload);
    });

    return list;
}
